import React, { useRef } from 'react';
import { Promotion } from 'types/utils';
import { ColorValueStrict } from 'fronton-react';
import { usePromoViewEvent } from '../../hooks';
import { LinkProps, LinkWithGAPromoClick } from '../link';
import { BannerStyledSection, bannerLink } from './banner-styles';
import { BannerMediaProps, BannerMedia, BannerContent } from './components';

type ContentWithChildren = {
  children: React.ReactNode;
  content?: never;
};

type ContentWithProps = {
  children?: never;
  content: {
    media: BannerMediaProps;
    title: string;
    text: string;
    textColor?: ColorValueStrict;
  };
};

type BannerProps = {
  bgColor: ColorValueStrict | string;
  elementBlock: string;
  link: Omit<LinkProps, 'children'>;
  onClick?: () => void;
  promotion: Promotion;
} & (ContentWithChildren | ContentWithProps);

export const Banner: React.FC<BannerProps> = ({
  bgColor,
  elementBlock,
  link,
  onClick,
  promotion,
  children,
  content,
}) => {
  const bannerRefs = useRef<HTMLAnchorElement[]>([]);

  usePromoViewEvent(bannerRefs, elementBlock, [promotion]);

  return (
    <BannerStyledSection bgColor={bgColor}>
      <LinkWithGAPromoClick
        bannerRefs={bannerRefs}
        className={bannerLink}
        position={0}
        promotion={promotion}
        elementBlock={elementBlock}
        onClick={onClick}
        {...link}
      >
        {children || (
          <>
            {content?.media && <BannerMedia {...content.media} />}
            <BannerContent title={content?.title} text={content?.text} textColor={content?.textColor} />
          </>
        )}
      </LinkWithGAPromoClick>
    </BannerStyledSection>
  );
};
